/** Afișare sigură a descrierilor: scoate tag-urile HTML rămase din feed-urile furnizorilor. */
export const cleanDescription = (text) => {
  if (!text) return '';
  let value = String(text);
  if (value.includes('<') || value.includes('&')) {
    value = value
      .replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, ' ')
      .replace(/<\/(p|div|li|tr|h[1-6]|ul|ol|table)>|<br\s*\/?>/gi, '\n')
      .replace(/<[^>]+>/g, ' ');
    const doc = typeof document !== 'undefined' ? document.createElement('textarea') : null;
    if (doc) { doc.innerHTML = value; value = doc.value; }
  }
  return value
    .replace(/\u00a0/g, ' ')
    .split('\n')
    .map((line) => line.replace(/[ \t]{2,}/g, ' ').trim())
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};

export default cleanDescription;
